module.exports = __webpack_public_path__ + "static/img/brees-2007-img-in-copy.bf0723c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2007-img-in-copy.jpg
// module id = Pfpg
// module chunks = 1